// @ts-check
// Caminho de volta "?from=" das telas que abrem outra e voltam (spec-2.0.0, K20): "Criar modelo" do seletor de modelo,
// atalhos dos editores da campanha e do nó do fluxo. Movido de client/src/lib/whatsapp-templates.js, que reexporta.

/**
 * Caminho de volta aceito só dentro do CRM: começa com uma barra, sem "//" nem barra invertida (que levariam a outro
 * site), sem caracteres de controle, até 512 caracteres e fora da própria tela (`ownPath`, quando dado).
 * @param {unknown} value @param {string | null} [ownPath]
 * @returns {string | null}
 */
export function readReturnPath(value, ownPath = null) {
  if (typeof value !== 'string' || value.length > 512 || !value.startsWith('/')) return null;
  if (value.startsWith('//') || value.includes('\\') || /[\u0000-\u001f]/.test(value)) return null;
  if (ownPath && (value === ownPath || value.startsWith(`${ownPath}?`) || value.startsWith(`${ownPath}/`))) return null;
  return value;
}
